import { useQuery } from '@apollo/client/react';

import { gql } from '@graphql/__generated__';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';

export const GET_TENANT_INTEGRATIONS = gql(/* GraphQL */ `
  query GetTenantIntegrations($id: uuid!) {
    stripe: tenants_aggregate(
      where: {
        id: { _eq: $id }
        stripe_secret_key: { _is_null: false, _neq: "" }
      }
    ) {
      aggregate {
        count
      }
    }
    close: tenants_aggregate(
      where: { id: { _eq: $id }, close_api_key: { _is_null: false, _neq: "" } }
    ) {
      aggregate {
        count
      }
    }
  }
`);

export const useTenantIntegrations = () => {
  const { me } = useAppData();
  const tenantId = me?.tenant_id;

  const { data, loading } = useQuery(GET_TENANT_INTEGRATIONS, {
    variables: { id: tenantId ?? '' },
    skip: tenantId == null,
  });

  return {
    loading,
    hasStripeKey: (data?.stripe?.aggregate?.count ?? 0) > 0,
    hasCloseKey: (data?.close?.aggregate?.count ?? 0) > 0,
  };
};
